import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'delete-action-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.scss'],
    imports: [SweetAlert2Module]
})
export class DeleteButtonTableComponent implements OnInit {
    @Input() idEntity: string;
    @Output() deleteEvent = new EventEmitter<string>();

    constructor() { }

    ngOnInit() {
    }

    deleteAction(event) {
        this.deleteEvent.emit(String(this.idEntity));
    }

}
